module.exports = __webpack_public_path__ + "static/team-photo-skrzyczne-ea50bb31c2ef20b07eb2a75942a7251e.jpg";